
import { defineComponent, PropType } from "vue";
import { Skill, SkillProgress } from "@/types";
import rules from "@/shared/constants/rules";

interface Data {
	skills: Skill[];
}

export default defineComponent({
	name: "AddNewSkill",
	emits: ["add", "close"],
	props: {
		existedSkills: {
			type: Array as PropType<SkillProgress[]>,
			default: () => [],
		},
	},
	data(): Data {
		return {
			skills: rules.SKILLS.filter(
				(skill) =>
					!this.existedSkills?.find((s) => s.name === skill.name)
			)
				.map((e) => {
					return {
						...e,
						localizedName: this.$t(`skill__${e.name}`),
					};
				})
				.sort((a, b) => a.localizedName.localeCompare(b.localizedName)),
		};
	},
	methods: {
		add(skillName: string) {
			this.$emit("add", {
				name: skillName,
				level: 1,
				experience: 0,
			});
			this.$emit("close");
		},
	},
});
